__turbopack_context__.v({
  "learning_media_badge": "LearningMediaBadge-module-scss-module__MXny4G__learning_media_badge",
  "learning_media_badge__button": "LearningMediaBadge-module-scss-module__MXny4G__learning_media_badge__button",
  "learning_media_badge__copy_long": "LearningMediaBadge-module-scss-module__MXny4G__learning_media_badge__copy_long",
  "learning_media_badge__copy_short": "LearningMediaBadge-module-scss-module__MXny4G__learning_media_badge__copy_short",
});
